import '../styles/output.css';
import '../styles/global.css';
import Banner from './Banners';
//return services
let Services =()=>{
    return(
        <div className='main px-2 py-3 bg-neutral-950 shadow-md shadow-neutral-900 break-2:px-9'>
            {/* Header container */}
            <div className='py-3'>
                <h3 className='font-bold text-xl text-white px-2 py-1 underline decoration-yellow-400'>Services</h3>
            </div>
            {/* Service cards container */}
            <div className='flex flex-col justify-center items-center sm:flex-row sm:flex-wrap sm:justify-start px-2'>
                
                <div className='flex flex-col w-[300px]  h-36 border-md bg-neutral-950 shadow-md shadow-neutral-900 p-[10px] m-[10px] '>
                    <div className='flex flex-row'>
                        <Banner/>
                        <span className='font-bold text-white'>Cover Art</span>
                    </div>
                    <p className='text-white'>I design custom album covers that capture your sound, your story, and your style. From concept to final artwork.
                </p>
                </div>
                
                 <div className='flex flex-col  w-[300px] h-36 border-md bg-neutral-950 shadow-md shadow-neutral-900 p-[10px] m-[10px]'>
                    <div className='flex flex-row'>
                        <Banner/>
                        <span className='font-bold text-white'>Poster design</span>
                    </div>
                    <p className='text-white' >Turning ideas into eye-catching posters that demand attention.</p>
                </div>

                 <div className='flex flex-col w-[300px] h-36 border-md bg-neutral-950 shadow-md shadow-neutral-900 p-[10px] m-[10px]'>
                    <div className='flex flex-row'>
                        <Banner/>
                        <span className='font-bold text-white'>YouTube Thumbnail Design</span>
                    </div>
                    <p className='text-white'>Designing bold, scroll-stopping thumbnails that get content noticed.</p>
                </div>

                {/* <Card title='Cover Art' src={'/images/icons/cover-art.png'}>
                  I design custom album covers that capture your sound, your story, and your style. From concept to final artwork.
                </Card>
                <Card title='Poster Design' src={'/logo192.png'}>
                 Turning ideas into eye-catching posters that demand attention.
                                 </Card>
                <Card title='Banner Design' src={'/logo192.png'}>
                 Designing bold, scroll-stopping banners that get your brand noticed.
                </Card> */}
                
            </div>
        </div>
    )
}
export default Services;